export const SupportLinks = {
  USER_GUIDES: 'https://www.safeguardequipment.com/prouserguides/',
  PRIVACY_POLICY: 'https://www.safeguardequipment.com/privacy-policy-apps/',
  END_USER_LICENSE_AGREEMENT:
    'https://www.safeguardequipment.com/end-user-license-agreement/',
};

export default SupportLinks;
